export const dinnerRoute = [
    {
        path: "/dinner",
        name: "dinner",
        component: ()=>import("@/views/dinner/index.vue"),
    },{
        path:"/dinnerDetail",
        name:"dinnerDetail",
        component: ()=>import("@/views/dinner/detail.vue"),
    },
]
